import { COMPANY_INFO } from 'consts/companyInfo';
import { SITE_URL } from 'consts/environmental';
import { EXTERNAL_URLS } from 'consts/externalUrls';

export const SCHEMA_ORG_SCRIPT = `{
  "@context": "http://schema.org",
  "@type": "Organization",
  "@id": "https://curology.com/#organization",
  "name" : "Curology",
  "legalName" : "Curology Inc.",
  "alternateName": "Curology",
  "description" : "Curology makes skincare customized for you",
  "url": "${SITE_URL}",
  "email": "${COMPANY_INFO.emails.support}",
  "logo": "${SITE_URL}/images/logos/curology-c-logo.png",
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "telephone": "+1-415-200-2060",
      "contactType": "customer support",
      "availableLanguage": ["English", "Spanish"],
      "areaServed": "US"
    },
    {
      "@type": "ContactPoint",
      "contactType": "media relations",
      "email": "press@curology.com"
    }
  ],
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "${COMPANY_INFO.sanDiego.addressLine1}",
    "addressLocality": "San Diego",
    "addressRegion": "CA",
    "postalCode": "92121",
    "addressCountry": "US"
  },
  "foundingDate": "2014",
  "foundingLocation": { "@type": "Place", "name": "San Diego, CA" },
  "brand": [
    { "@type": "Brand", "name": "Curology" },
    { "@type": "Brand", "name": "Agency" }
  ],
  "knowsAbout": [
    "acne treatment",
    "teledermatology",
    "tretinoin",
    "custom prescription skincare",
    "anti-aging",
    "rosacea",
    "hyperpigmentation",
    "hair loss",
    "personalized skincare",
    "dermatologist care"
  ],
  "award": [
    "Vogue 'Best Overall Tretinoin Cream' for Curology Custom FormulaRx",
    "Vogue 'Best Tretinoin for Sensitive Skin' for Curology HydroTret Rx",
    "2025 Cosmopolitan Acne Award for DayPrime Rx prescription primer"
  ],
  "sameAs" : [
    "${EXTERNAL_URLS.facebook}",
    "${EXTERNAL_URLS.twitter}",
    "${EXTERNAL_URLS.instagram}",
    "${EXTERNAL_URLS.youtube}",
    "${EXTERNAL_URLS.pinterest}",
    "${EXTERNAL_URLS.linkedin}",
    "${EXTERNAL_URLS.tiktok}"
  ]
}`;
